module.exports = __webpack_public_path__ + "static/media/pin-icon.c3c76220.svg";